import React, { useEffect, useState } from "react";
import { Map as MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Row } from "reactstrap";
import L from "leaflet";
import redPoint from "../../assets/images/maps/marker-icon-red.png";
import greenPoint from "../../assets/images/maps/marker-icon-green.png";
import bluePoint from "../../assets/images/maps/marker-icon-blue.png";
import purplePoint from "../../assets/images/maps/marker-icon-purple.png";
import purplePoint2 from "../../assets/images/maps/marker-icon-purple2.png";
import blackPoint from "../../assets/images/maps/marker-icon-black.png";
import yellowPoint from "../../assets/images/maps/marker-icon-yellow.png";
import greyPoint from "../../assets/images/maps/marker-icon-grey.png";
import redPointGif from "../../assets/images/maps/marker-icon-red.gif";
import greenPointGif from "../../assets/images/maps/marker-icon-green.gif";
import bluePointGif from "../../assets/images/maps/marker-icon-blue.gif";
import purplePointGif from "../../assets/images/maps/marker-icon-purple.gif";
import purplePoint2Gif from "../../assets/images/maps/marker-icon-purple2.gif";
import blackPointGif from "../../assets/images/maps/marker-icon-black.gif";
import yellowPointGif from "../../assets/images/maps/marker-icon-yellow.gif";
import greyPointGif from "../../assets/images/maps/marker-icon-grey.gif";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon.png").default,
  iconUrl: require("leaflet/dist/images/marker-icon.png").default,
  shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
});

const MapsLeaflet = ({ dados = [], title = "MAPA DE MONITORAMENTO" }) => {
  const alarmSaga = (item) => {
    let txt = "";
    if (item.indexOf("Corte") !== -1) {
      if (txt.length > 1) {
        txt += ", ";
      }
      txt = "Corte de Cabo do Pulso";
    }
    if (item.indexOf("Status") !== -1) {
      if (txt.length > 1) {
        txt += ", ";
      }
      txt += "Possível Vazamento";
    }
    if (item.indexOf("Ataque") !== -1) {
      if (txt.length > 1) {
        txt += ", ";
      }
      txt += "Ataque Magnético";
    }
    return txt;
  };
  const formatArray = (data) => {
    let arr = [];
    data.map((elem) => {
      arr.push({
        key: elem.CD_META_DEVICE + elem.OID_EQUIPAMENTO_LORA,
        longitude: elem.DS_LOCALIZACAO_LONGITUDE,
        latitude: elem.DS_LOCALIZACAO_LATITUDE,
        equip: elem.NR_HIDROMETRO,
        device: elem.CD_META_DEVICE_ADDR,
        location: elem.DS_LOCALIDADE,
        alarm:
          elem.STATUS == "AZUL"
            ? alarmSaga(elem.DESCRICAO_STATUS)
            : elem.DESCRICAO_STATUS,
        icone: elem.NR_ORDEM_SERVICO ? iconsGif[elem.STATUS] : icons[elem.STATUS],
        status: elem.STATUS,
        os: elem.NR_ORDEM_SERVICO,
        servico: elem.DS_SERVICO,
        status_os: elem.DS_STATUS_OS,
      });
    });
    return arr;
  };
  const initPosition = [-18.918, -48.2766];
  const initZoom = 12;
  const [position, setPosition] = useState(initPosition);
  const [zoom, setZoom] = useState(initZoom);
  const [search, setSearch] = useState("");
  const [clickedMarker, setClickedMarker] = useState(null);
  const [encontrado, setEncontrado] = useState(true);

  const [exibir, setExibir] = useState({
    PRETO: true,
    AZUL: true,
    VERDE: true,
    AMARELO: true,
    VERMELHO: true,
    DESCONHECIDO: true,
  });

  const iconsEnum = {
    PRETO: "A mais de 90 dias sem pulso",
    AZUL: "Com Alarme SAGA",
    VERDE: "Em funcionamento",
    AMARELO: " Sem consumo a mais de 12h",
    VERMELHO: "Mais de 24 horas sem pulso",
    DESCONHECIDO: "Situação desconhecida",
  };

  const getIcon = (status) => {
    return new L.Icon({
      iconUrl: status,
      iconSize: [24, 32],
      iconAnchor: [8, 16],
      popupAnchor: [0, -16],
    });
  };

  const icons = {
    PRETO: getIcon(blackPoint),
    AZUL: getIcon(bluePoint),
    ROXO: getIcon(purplePoint2),
    "ROXO-CLARO": getIcon(purplePoint),
    VERDE: getIcon(greenPoint),
    AMARELO: getIcon(yellowPoint),
    VERMELHO: getIcon(redPoint),
    DESCONHECIDO: getIcon(greyPoint),
  };

    const iconsGif = {
    PRETO: getIcon(blackPointGif),
    AZUL: getIcon(bluePointGif),
    ROXO: getIcon(purplePoint2Gif),
    "ROXO-CLARO": getIcon(purplePointGif),
    VERDE: getIcon(greenPointGif),
    AMARELO: getIcon(yellowPointGif),
    VERMELHO: getIcon(redPointGif),
    DESCONHECIDO: getIcon(greyPointGif),
  };

  const [location, setLocation] = useState(formatArray(dados));
  const [equipamentos, setEquipamentos] = useState(location);

  useEffect(() => {
    const elements = document.getElementsByClassName(
      "leaflet-attribution-flag"
    );
    for (let element of elements) {
      element.style.setProperty("display", "none", "important");
    }
  }, []);

  function filterData() {
    let tmp = [];
    formatArray(dados).map((elem) => {
      const deveExibir = Object.keys(exibir).some((chave) => {
        return exibir[chave] && elem.status === chave;
      });
      if (deveExibir) tmp.push(elem);
    });
    setEquipamentos(tmp);
    setPosition(initPosition);
    setZoom(initZoom);
    setClickedMarker(null);
    setEncontrado(true);
    setSearch("");
  }
  const centralizar = () => {
    if (search.length > 0) {
      let equipamento = equipamentos.find(
        (item) =>
          item.device.toLowerCase() === search.toLowerCase() ||
          item.equip.toLowerCase() === search.toLowerCase()
      );
      if (equipamento) {
        if (
          position[0] == equipamento.latitude &&
          position[1] == equipamento.longitude
        ) {
          equipamento.latitude = equipamento.latitude + "1";
          equipamento.longitude = equipamento.longitude + "1";
        }
        setClickedMarker(null);
        setClickedMarker(equipamento.device);
        setPosition([equipamento.longitude, equipamento.latitude]);
        equipamento.latitude = equipamento.latitude + "1";
        equipamento.longitude = equipamento.longitude + "1";
        setPosition([equipamento.longitude, equipamento.latitude]);
        setClickedMarker(equipamento.device);
        if (zoom == 16) {
          setZoom(17);
        } else {
          setZoom(16);
        }
        setEncontrado(true);
      } else {
        setEncontrado(false);
      }
    }
  };

  useEffect(() => {
    filterData();
  }, [exibir]);

  useEffect(() => {
    filterData();
    centralizar();
  }, [dados]);

  return (
    <React.Fragment>
      <Row>
        <div style={{ width: "100vw", height: "100vh", position: "relative" }}>
          <h1
            style={{
              textAlign: "center",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255,0.5)",
              margin: 0,
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              display: "inline-block",
              top: "7px",
            }}
          >
            {title}
          </h1>

          <details
            style={{
              position: "absolute",
              left: "70px",
              top: "15px",
              zIndex: 1000,
              backgroundColor: "rgba(255,255,255,0.5)",
              margin: 0,
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
          >
            <summary style={{ fontWeight: "bold" }}>Alarmes</summary>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                marginTop: "10px",
              }}
            >
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibir.PRETO}
                  onChange={() => {
                    setExibir((prev) => ({ ...prev, PRETO: !prev.PRETO }));
                  }}
                />{" "}
                {iconsEnum.PRETO}
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibir.AZUL}
                  onChange={() => {
                    setExibir((prev) => ({ ...prev, AZUL: !prev.AZUL }));
                  }}
                />{" "}
                {iconsEnum.AZUL}
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibir.AMARELO}
                  onChange={() => {
                    setExibir((prev) => ({ ...prev, AMARELO: !prev.AMARELO }));
                  }}
                />{" "}
                {iconsEnum.AMARELO}
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibir.VERDE}
                  onChange={() => {
                    setExibir((prev) => ({ ...prev, VERDE: !prev.VERDE }));
                  }}
                />{" "}
                {iconsEnum.VERDE}
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibir.VERMELHO}
                  onChange={() => {
                    setExibir((prev) => ({
                      ...prev,
                      VERMELHO: !prev.VERMELHO,
                    }));
                  }}
                />{" "}
                {iconsEnum.VERMELHO}
              </label>
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="checkbox"
                  checked={exibir.DESCONHECIDO}
                  onChange={() => {
                    setExibir((prev) => ({
                      ...prev,
                      DESCONHECIDO: !prev.DESCONHECIDO,
                    }));
                  }}
                />{" "}
                {iconsEnum.DESCONHECIDO}
              </label>
            </div>
          </details>

          <input
            type="text"
            placeholder="Pesquisar hidrômetro ou device..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                centralizar();
              }
            }}
            style={{
              position: "absolute",
              right: "180px",
              top: "20px",
              zIndex: 1001,
              backgroundColor: "rgba(255,255,255,0.8)",
              padding: "8px 15px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              width: "200px",
            }}
          />
          <button
            style={{
              position: "absolute",
              right: "130px",
              top: "20px",
              zIndex: 1001,
              backgroundColor: "rgb(24 202 255 / 38%)",
              padding: "8px 15px",
              borderRadius: "8px",
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            onClick={() => centralizar()}
          >
            <i className="fas fa-search"></i>
          </button>
          <MapContainer
            center={position}
            zoom={zoom}
            style={{ height: "100vh", width: "100%" }}
          >
            {!encontrado && (
              <div
                style={{
                  position: "absolute",
                  top: "60px",
                  right: "180px",
                  backgroundColor: "#fff3cd",
                  color: "#856404",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ffeeba",
                  zIndex: 1001,
                }}
              >
                Nenhum resultado encontrado
              </div>
            )}
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

            {equipamentos?.map((data, key) => (
              <Marker
                key={data.key}
                ref={(ref) => {
                  if (clickedMarker === data.device && ref) {
                    ref.leafletElement.openPopup();
                  } else if (ref?.leafletElement) {
                    ref.leafletElement.closePopup();
                  }
                }}
                position={[data.longitude, data.latitude]}
                icon={data.icone}
              >
                <Popup
                  onClose={() => {
                    setClickedMarker(null);
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Arial, sans-serif",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      background: "#ffffff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      maxWidth: "260px",
                      lineHeight: "1.4",
                    }}
                  >
                    <div
                      style={{
                        lineHeight: "1.4",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{ marginBottom: "10px", position: "relative" }}
                      >
                        <strong style={{ fontSize: "15px" }}>Device:</strong>
                        <div>{data.device}</div>

                        {/* Ícone flutuando no canto direito */}
                        <a
                          href={`/dashboard?${data.equip}`}
                          title="Dashboard"
                          style={{
                            backgroundColor: "#4a90e2",
                            color: "#fff",
                            borderRadius: "50%",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                            textDecoration: "none",
                            display: "flex",
                            lineHeight: 0,      // <- remove alinhamento estranho do ícone


                            position: "absolute", // <-- flutua
                            top: "0", // posição superior
                            right: "0", // alinhado à direita
                            transform: "translateY(-5px)", // opcional: sobe levemente
                          }}
                        >
                          <i
                            className="dripicons-arrow-right"
                            style={{ fontSize: 20 , padding: 0, margin: 0 }}
                          />
                        </a>
                      </div>
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <strong style={{ fontSize: "15px" }}>Hidrômetro:</strong>
                      <div>{data.equip}</div>
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <strong style={{ fontSize: "15px" }}>
                        Local de instalação:
                      </strong>
                      <div>{data.location}</div>
                    </div>

                    <div
                      style={{
                        margin: "12px 0",
                        height: "1px",
                        backgroundColor: "#e5e5e5",
                      }}
                    />

                    <div style={{ marginBottom: "12px" }}>
                      <strong style={{ fontSize: "15px" }}>Alarmes:</strong>
                      <div>{data.alarm}</div>
                    </div>

                    <div style={{ marginBottom: "8px" }}>
                      <strong>OS:</strong>{" "}
                      {data.os
                        ? data.os
                        : "Nenhuma OS definida para esta localização"}
                    </div>

                    {data.os ? (
                      <div
                        style={{
                          background: "#f7f7f7",
                          padding: "8px",
                          borderRadius: "6px",
                          border: "1px solid #e1e1e1",
                          fontSize: "13px",
                        }}
                      >
                        <div>Descrição do serviço: {data.servico}</div>
                        <div>Status: {data.status_os}</div>
                      </div>
                    ) : null}
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </Row>
    </React.Fragment>
  );
};

export default MapsLeaflet;
